import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

// 适配，样式
import 'lib-flexible'
import './styles/index.less'

// 插件
import './plugin/storage'
import './plugin/vconsole'
import './plugin/wxjssdk'
import './plugin/swiper'
// 指令
import directive from './directive'
directive(Vue)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  next()
})
